const RecommendationStatus = Object.freeze({
  TO_DO: 'to_do',
  IN_PROGRESS: 'in_progress',
  COMPLETED: 'completed',
  INACTIVE: 'inactive',
  ACTIVE: 'active',
})

export default RecommendationStatus